module.exports = __webpack_public_path__ + "media/financial_aid_videos/secrets_callout2-a5523f54.jpg";